import { render, staticRenderFns } from "./PalletPackageTypesFormInput.vue?vue&type=template&id=f821ad6e&scoped=true&"
import script from "./PalletPackageTypesFormInput.vue?vue&type=script&lang=js&"
export * from "./PalletPackageTypesFormInput.vue?vue&type=script&lang=js&"
import style0 from "./PalletPackageTypesFormInput.vue?vue&type=style&index=0&id=f821ad6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f821ad6e",
  null
  
)

/* custom blocks */
import block0 from "./PalletPackageTypesFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports